import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {
  MatButtonModule, MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule, MatNativeDateModule,
  MatRippleModule,
  MatSelect,
  MatSelectModule
} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';
import {AddEventPopUpComponent} from './add-event-pop-up/add-event-pop-up.component';
import {EventsService} from './events.service';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {rootRouterConfig} from './app.routing';
import {NavBarMenuComponent} from './nav-bar-menu/nav-bar-menu.component';
import {EventPopUpComponent} from './event-pop-up/event-pop-up.component';
import {FormsModule} from '@angular/forms';
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
import {FileUploadModule} from 'ng2-file-upload';
import { MainViewComponent } from './main-view/main-view.component';

@NgModule({
  declarations: [
    AppComponent,
    AddEventPopUpComponent,
    NavBarMenuComponent,
    EventPopUpComponent,
    MainViewComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    HttpClientModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatSelectModule,
    FormsModule,
    FileUploadModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    RouterModule.forRoot(rootRouterConfig, {useHash: false})
  ],
  providers: [EventsService],
  bootstrap: [AppComponent],
  entryComponents: [AddEventPopUpComponent, EventPopUpComponent]
})
export class AppModule {
}
